/* Progressive enhancement: content is always visible, including without JS. */
(() => {
  if (window.__murranaMotion) return;
  window.__murranaMotion = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Set();
  const selector = '.lv-section-head, .lv-product, .lv-collection, .lv-manifesto > h2, .lv-manifesto > p, .mv-editorial > h2, .mv-editorial > p, .mv-prose > h2, .mv-prose > p, .lv-closing > div, .mv-coming';
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (reduced.matches || !entry.target.animate) continue;
      const effect = entry.target.animate([
        { opacity: 0.35, transform: 'translateY(12px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 650, easing: 'cubic-bezier(.22,1,.36,1)' });
      running.add(effect);
      effect.onfinish = effect.oncancel = () => running.delete(effect);
    }
  }, { threshold: 0.08 }) : null;
  const setup = (root = document) => {
    if (!observer || reduced.matches || window.Shopify?.designMode) return;
    root.querySelectorAll(selector).forEach(el => {
      if (seen.has(el)) return;
      seen.add(el);
      observer.observe(el);
    });
  };
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      observer?.disconnect();
      for (const animation of running) animation.cancel();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  window.addEventListener('pagehide', () => { for (const animation of running) animation.cancel(); });
})();
